"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.structuredResourceSchema = exports.structuredResourceEntrySingularSchema = exports.structuredResourceEntrySchema = exports.structuredResourceEntryPluralSchema = void 0;
var _zod = require("zod");
// Zod schemas
const structuredResourceEntryBaseSchema = _zod.z.object({
  notes: _zod.z.string().optional().describe('Additional information for translators'),
  context: _zod.z.string().optional().describe('Context for translators, e.g. male/female; see https://lokalise.com/blog/the-3-pillars-of-context-that-will-improve-your-translations'),
  limit: _zod.z.number().optional().describe('Character limit'),
  tags: _zod.z.array(_zod.z.string()).optional().describe('See https://docs.lokalise.com/en/articles/1475552-tags')
});
const structuredResourceEntrySingularSchema = exports.structuredResourceEntrySingularSchema = structuredResourceEntryBaseSchema.extend({
  translation: _zod.z.string().describe('Singular translation')
});
const structuredResourceEntryPluralSchema = exports.structuredResourceEntryPluralSchema = structuredResourceEntryBaseSchema.extend({
  translation: _zod.z.object({
    one: _zod.z.string(),
    other: _zod.z.string()
  }).describe('Plural translation')
});
const structuredResourceEntrySchema = exports.structuredResourceEntrySchema = _zod.z.union([structuredResourceEntrySingularSchema, structuredResourceEntryPluralSchema]);
const structuredResourceSchema = exports.structuredResourceSchema = _zod.z.record(_zod.z.string(), structuredResourceEntrySchema);

/**
 * A dictionary of translations with additional metadata.
 * See https://docs.lokalise.com/en/articles/3229161-structured-json
 */